import numeral from 'numeral';

numeral.locale('se');

export class NullToEmptyStringValueConverter {
  toView(value) {
    if (value === null) return null;
    return numeral(value).format('0,0');
  }
  fromView(value) {
    // return value === '' ? null : value;
    if (value === null) return null;
    return numeral(value).value();
  }
}
